import { FunctionComponent } from 'react';
import { Security } from 'widgets/PersonalAccount/ui/tabs/Security';

const AdminPersonalAccount: FunctionComponent = () => {
	return <Security />;
};

export default AdminPersonalAccount;
